import { ScopeIds } from "../config/config";
import { LineStyle, LineWidth, MinorLabelsOverlap, MinorTxtStyle, PivotTxtFlgs, PivotType, SizeProps, StructMoveStyle, StructSwingStyle } from "../config/smpa";
import { hub } from "../hub";
import { TVContext } from "../hub/context";
import { isSet } from "../storage";
import { IconId, getColor, halign_center, halign_right, hrTool, iconTool, tlTool, tvpoint, valign_bottom, valign_center, valign_top } from "../tv";
import { BosInfo, SmpaTFInfo, StructBosFacilityType, StructLevel, StructMove } from "./smpainfo";
import { styleSet } from "./styles";
import { markTools } from "./tools";
import { dirTool } from "./toolsset";

class structCounter {
    private parent: structCounter;
    private parents = 0;
    private parentOff = 0;
    private max: number;
    public cur: number;

    init(max: number, parents: number, parentOff = 0) {
        if (max == null || max <= 0)
            this.max = null;
        else
            this.max = max;
        this.cur = 0;
        this.parents = parents;
    }
    get on(): boolean {
        let r = false;
        if (this.max == null) {
            if (this.parent == null)
                return true;
            r = true;
        }
        else if (this.cur < this.max) {
            if (this.parent == null)
                return true;
            r = true;
        }
        if (r) {
            if (!this.parent.on) {
                this.cur = this.max;
                r = false;
            }
            else {
                if (this.parents > 0 && (this.parent.cur - this.parentOff) >= this.parents) {
                    this.cur = this.max;
                    r = false;
                }
            }
        }
        return r;
    }
    add() {
        this.cur++;
    }
    setParent(parent: structCounter) {
        this.parent = parent;
    }
}

class structCounters {
    bos: structCounter = new structCounter();
    pivot: structCounter = new structCounter();
    total: structCounter = new structCounter();

    setParent(parent: structCounters) {
        this.bos.setParent(parent.pivot);//we set pivots to count parent on moves
        this.pivot.setParent(parent.pivot);
    }
    init(style: StructMoveStyle) {
        this.total.init(swingStructTool.max, 0);
        this.pivot.init(style.pivot.max, style.pivot.parents);
        this.bos.init(style.bos.max, style.bos.parents, 1);
    }
}

export interface IDrawnPivot {
    idx: number;
    state: structFractalState;
    icon: iconTool;
    label: tlTool;
}
export interface IDrawn {
    pvs: Map<number, IDrawnPivot>;
    b: Map<number, tlTool>;
}
class structFractalState {
    index: number;
    trends: dirTool<tlTool>[];
    boses: dirTool<tlTool>[];
    buTextCol: string;
    beTextCol: string;
    lvlBuTextCol: string;
    lvlBeTextCol: string;
    bosBuTextCol: string;
    bosBeTextCol: string;
    buCol: string;
    beCol: string;
    pivots: pivotTool<iconTool>[];
    pivotNames: pivotTool<tlTool>[];
    levels: dirTool<hrTool>[];
    bosStype: styleSet;
    counter: structCounters;
    style: StructMoveStyle;
    anyToRender: boolean;
    anyToRenderNext: boolean;
    supportsFbos: boolean;
    supportsLvls: boolean;
    constructor(index: number) {
        this.index = index;
        this.trends = [];
        this.boses = [];
        this.pivots = [];
        this.pivotNames = [];
        this.levels = [];
        this.anyToRender = this.anyToRenderNext = false;
        this.supportsFbos = false;
        this.supportsLvls = false;
    }
}

interface pivotTool<Tool> extends dirTool<Tool> {
    isLow: boolean;
    pt: tvpoint;
}
export class structTool {
    tvd: TVContext;
    fractal: structTool;
    states: structFractalState[] = [];
    /*	max: number = null;*/
    simple: boolean;
    constructor(tv: TVContext, fractal: structTool, simple: boolean = false) {
        this.simple = simple;
        this.tvd = tv;
        this.fractal = fractal;
        this.updateView();
    }
    static isBull(f: number) {
        return (f & 1) == 1;
    }
    static isBullTrend(f: number) {
        return ((f >> 1) & 1) == 1;
    }
    static getLevel(f: number) {
        return (f >> 2);
    }
    static isVirtual(move: StructMove) {
        return ((move.f >> 2) & 1) == 1;
    }
    static isStartTrend(move: StructMove) {
        return ((move.f >> 3) & 1) == 1;
    }
    getStyle(lvl: number): StructMoveStyle { return null; }


    private addPivot(state: structFractalState, info: string, p: tvpoint, bullTrend: boolean, isBull: boolean, isVirtual: boolean): tlTool {
        if (info == null)
            return null;
        if (this.simple) {
        } else if (info.length == 0) {
            return null;
        }

        const color = bullTrend ? state.buTextCol : state.beTextCol;
        const tool = new tlTool(this.tvd, color, LineWidth.w1, color, LineStyle.solid, state.style.pivot.size);
        /*tool.setAligns(valign_center, halign_center);*/
        if (!isBull)
            tool.setAligns(valign_bottom, halign_center, state.style.pivot.txtSz);
        else
            tool.setAligns(valign_top, halign_center, state.style.pivot.txtSz);
        const pt = this.getPtByOff(p, state.style.pivot, !isBull);
        tool.build(pt, pt);

        tool.setText(info);
        state.pivotNames.push({
            tool: tool,
            isBull: bullTrend,
            pt: p,
            isLow: !isBull
        });
        return tool;
    }

    protected buildState(idx: number) {
        this.states.push(new structFractalState(idx))
        this.initStateView(idx);

        const counter = this.states[this.states.length - 1].counter = new structCounters();
        if (this.states.length > 1)
            counter.setParent(this.states[this.states.length - 2].counter);
        counter.init(this.getStyle(idx));
        if (idx > 0 && this.states[idx].anyToRender)
            this.states[idx - 1].anyToRenderNext = true;
    }

    protected getColor(idx: number, isBull: boolean, opacity: number = null) {
        let color = isBull ? this.getStyle(idx).buCol : this.getStyle(idx).beCol;
        if (opacity == null)
            return getColor(color);
        return getColor(color, opacity / 100);
    }

    protected afterInitView(idx: number) { }
    private initStateView(idx: number) {
        const s = this.getStyle(idx);
        const state = this.states[idx];
        state.anyToRender = s.bos.on || s.pivot.on || s.trend.on;
        state.anyToRenderNext = this.simple && state.anyToRender;
        state.style = s;
        state.bosBeTextCol = this.getColor(idx, false, s.bos.txtOp);
        state.bosBuTextCol = this.getColor(idx, true, s.bos.txtOp);
        state.beTextCol = this.getColor(idx, false, s.pivot.txtOp);
        state.buTextCol = this.getColor(idx, true, s.pivot.txtOp);
        state.buCol = this.getColor(idx, true);
        state.beCol = this.getColor(idx, false);
        this.afterInitView(idx);

        state.trends.forEach(x => x.isBull ? x.tool.setColor(state.buCol) : x.tool.setColor(state.beCol));
        state.boses.forEach(x => x.isBull ? x.tool.setColor(state.buCol, state.bosBuTextCol) : x.tool.setColor(state.beCol, state.bosBeTextCol));
        state.pivots.forEach(x => x.isBull ? x.tool.setColor(state.buCol) : x.tool.setColor(state.beCol));
        state.pivotNames.forEach(x => x.isBull ? x.tool.setColor(state.buTextCol) : x.tool.setColor(state.beTextCol));
        state.levels.forEach(x => x.isBull ? x.tool.setColor(state.buCol, state.lvlBuTextCol) : x.tool.setColor(state.beCol, state.lvlBeTextCol));
    }
    updateView() {
        for (let idx = this.states.length - 1; idx >= 0; idx--)
            this.initStateView(idx);
        return false;
    }
    protected priceOff: number;



    private calcPriceOff() {
        if (!this.tvd.isTvReady()) {
            this.priceOff = 0;
            return false;
        }
        const pane = this.tvd.tv.activeChart().getPanes()[0];
        const height = pane.getHeight();
        try {
            const priceRange = pane.getMainSourcePriceScale().getVisiblePriceRange();
            if (!priceRange) {
                this.priceOff = 0;
                return false;
            }
            this.priceOff = (priceRange.to - priceRange.from) / height;
            return true;
        } catch {

        }
        return false;
    }
    build(mi: SmpaTFInfo, drawn: Map<number, IDrawn>) {
        this.calcPriceOff();
    }

    public static getNum(i: number, up: boolean, style: MinorTxtStyle) {
        switch (style) {
            case MinorTxtStyle.Letter:
                return up ? String.fromCharCode(i - 1 + 65) : String.fromCharCode(i - 1 + 97);
            case MinorTxtStyle.Rome:
                return getRome();
            default:
                return i.toString();
        }
        function getRome() {
            switch (i) {
                case 1:
                    return up ? 'I' : 'i';
                case 2:
                    return up ? 'II' : 'ii';
                case 3:
                    return up ? 'III' : 'iii';
                case 4:
                    return up ? 'IV' : 'iv';
                case 5:
                    return up ? 'V' : 'v';
                case 6:
                    return up ? 'VI' : 'vi';
                case 7:
                    return up ? 'VII' : 'vii';
                case 8:
                    return up ? 'VIII' : 'viii';
                case 9:
                    return up ? 'IX' : 'ix';
                case 10:
                    return up ? 'X' : 'x';
                default:
                    return i.toString();
            }
        }
    }
    private getPtByOff(p: tvpoint, size: SizeProps, isLow: boolean): tvpoint {
        return {
            t: p.t,
            p: p.p + size.off * this.priceOff * (isLow ? -1 : 1)
        };
    }

    onViewPortChanged() {
        if (!this.calcPriceOff())
            return;
        for (const state of this.states) {
            if (state.style.pivot.off == 0)
                continue;
            state.pivots.forEach(x => {
                x.tool.setPoints([this.getPtByOff(x.pt, state.style.pivot, x.isLow)]);
            });
            state.pivotNames.forEach(x => {
                const pt = this.getPtByOff(x.pt, state.style.pivot, x.isLow);
                x.tool.setPoints([pt, pt]);
            });
        }
    }
    protected buildMovesInternal(idx: number, moves: StructMove[], drawn: Map<number, IDrawn>, pid: number = null) {
        if (idx >= this.states.length)
            this.buildState(idx);

        if (idx == 0)
            for (let i = 0; i < this.states.length; i++) {
                const state = this.states[i];
                state.counter.init(state.style);
            }
        const state = this.states[idx];

        if (moves == null || moves.length == 0)
            return;

        const s = state.style;


        if (state.anyToRender) {
            let realDepth = null as {
                p: tvpoint,
                isLow: boolean,
                //isBullTrend: boolean;
                id: number,
                rotate: boolean;
            };

            let lastPv: tvpoint = null;
            let lastIsBullTrend: boolean = null;
            let presetPv: tvpoint = null;
            const checkDupes = this.fractal != null || this.simple;
            const combineDupes = hub.smcConfig.struct.swing.labover == MinorLabelsOverlap.Combine;
            for (let i = moves.length - 1; i >= -1; i--) {
                let move = i < 0 ? moves[0] : moves[i];

                let allow = state.counter.total.on;
                if (s.pivot.on && allow)
                    allow = state.counter.pivot.on;
                const isTrendOn = s.trend.on && allow;
                const isBullTrend = structTool.isBullTrend(move.f);

                if (isTrendOn) {
                    let fromPv: tvpoint = null;
                    if (i >= 0) {
                        if (this.simple) {
                            fromPv = move;
                        } else {
                            fromPv = presetPv ? presetPv : move;
                            if (move.b && move.st)
                                presetPv = move.st;
                            else
                                presetPv = null;
                        }
                    } else {
                        fromPv = move.st;
                    }
                    if (fromPv != null) {
                        if (lastPv) {
                            const line = new tlTool(this.tvd, lastIsBullTrend ? state.buCol : state.beCol, s.trend.lWidth, null, s.trend.lStyle);
                            if (this.simple)
                                line.setAligns(valign_center, halign_center);
                            line.build(fromPv, lastPv);
                            if (this.simple)
                                line.setText(idx.toString());
                            state.trends.push({ isBull: lastIsBullTrend, tool: line });
                        }
                        lastPv = fromPv;
                        lastIsBullTrend = isBullTrend;
                    }
                }

                if (i == -1)
                    continue;

                let isPvOn = s.pivot.on && allow;

                const isFBosOn = state.supportsFbos && state.counter.bos.on && allow;
                const isBosOn = s.bos.on && state.counter.bos.on && allow;
                const isLow = !structTool.isBull(move.f);
                let b = i >= 0 ? move.b : null;
                if (b)
                    if (b.i == BosInfo.ch && !s.bos.showrev)
                        b = null;
                    else if (b.i == BosInfo.bos && !s.bos.showbos)
                        b = null;

                if (move.fb && isFBosOn && this.fractal) {
                    const fstate = this.fractal.states[0];
                    const fs = fstate.style;
                    const line = new tlTool(this.tvd, isBullTrend ? fstate.buCol : fstate.beCol, fs.bos.lWidth, isBullTrend ? fstate.bosBuTextCol : fstate.bosBeTextCol, fs.bos.lStyle);
                    line.build(move.fb.f, move.fb.t);
                    fstate.boses.push({
                        isBull: isBullTrend,
                        tool: line
                    });
                }

                if (b && isBosOn) {
                    let drawnState = drawn.get(b.f.t);
                    if (drawnState == null)
                        drawn.set(b.f.t, drawnState = { pvs: null, b: null });
                    if (drawnState.b == null)
                        drawnState.b = new Map<number, tlTool>();
                    let line = drawnState.b.get(b.t.t);
                    let debugInfo: string = null;
                    if (s.bos.txtOn
                        && hub.options.isAdmin
                        && hub.smcConfig.struct.pon
                        && b.fa) {
                        let t = b.fa.t;
                        let hasai = false;
                        if (isSet(t, StructBosFacilityType.AI)) {
                            t ^= StructBosFacilityType.AI;
                            hasai = true;
                        }
                        debugInfo = ' ' + b.fa.a + '[' + b.fa.c + ']' + StructBosFacilityType[b.fa.t];
                        if (hasai)
                            debugInfo += ',ai';
                    }
                    if (line) {
                        if (s.bos.txtOn) {
                            //let info = idx == 0 ? '' : structTool.getNum(idx, s.bos.txtUC, hub.smcConfig.struct.swing.minorTxtStyle) + '-';
                            let info = getBosName();
                            let prev = line.getText();
                            if (prev)
                                prev += ',' + info;
                            else
                                prev = info;
                            if (debugInfo)
                                prev += debugInfo;
                            line.setText(prev);
                        }
                    }
                    else {
                        line = new tlTool(this.tvd, isBullTrend ? state.buCol : state.beCol, s.bos.lWidth, isBullTrend ? state.bosBuTextCol : state.bosBeTextCol, s.bos.lStyle);
                        if (isLow)
                            line.setAligns(valign_bottom, markTools.getAlign(s.bos), s.bos.txtSz);
                        else
                            line.setAligns(valign_top, markTools.getAlign(s.bos), s.bos.txtSz);
                        line.build(b.f, b.t);
                        if (s.bos.txtOn) {
                            //let info = idx == 0 ? '' : structTool.getNum(idx, s.bos.txtUC, hub.smcConfig.struct.swing.minorTxtStyle) + '-';
                            let info = getBosName();
                            if (debugInfo)
                                info += debugInfo;
                            line.setText(info);
                        }
                        state.boses.push({
                            isBull: isBullTrend,
                            tool: line
                        });
                        drawnState.b.set(b.t.t, line);
                    }
                    function getBosName() {
                        let info = '';
                        if (hub.config.chart.scopeId == ScopeIds.BodyStr && idx != 0)
                            info = structTool.getNum(idx, s.bos.txtUC, hub.smcConfig.struct.swing.minorTxtStyle) + '-';
                        let name = b.i == BosInfo.ch ? s.bos.revname : s.bos.bosname;
                        if (!name)
                            name = BosInfo[b.i];
                        return name;
                    }
                }

                if (isPvOn) {
                    let rotate = isLow;
                    let prev = drawn.get(move.t);
                    let drawnState = prev?.pvs?.get(move.p);
                    let dupe = !(prev == null || drawnState == null || drawnState.idx > idx || this.fractal == null);
                    if (checkDupes && !dupe) {
                        if (prev == null)
                            drawn.set(move.t, prev = { pvs: null, b: null });
                        if (prev.pvs == null)
                            prev.pvs = new Map<number, IDrawnPivot>();

                        if (drawnState?.icon != null) {
                            drawnState.icon.clear();
                            drawnState.state.pivots.splice(drawnState.state.pivots.findIndex(x => x.tool == drawnState.icon), 1);
                        }
                        if (drawnState?.label != null) {
                            drawnState.label.clear();
                            drawnState.state.pivotNames.splice(drawnState.state.pivotNames.findIndex(x => x.tool == drawnState.label), 1);
                        }
                        drawnState = {
                            idx: idx,
                            state: state,
                            icon: null,
                            label: null
                        };
                        prev.pvs.set(move.p, drawnState);
                    }
                    let id = IconId.Circle;
                    rotate = !isLow;
                    switch (state.style.pivot.type) {
                        case PivotType.Circle:
                            id = structTool.isVirtual(move) ? IconId.VirtCircle : IconId.Circle;
                            break;
                        case PivotType.Tick:
                            id = structTool.isVirtual(move) ? IconId.VirtArrow : IconId.Arrow;
                            break;
                        case PivotType.Triangle:
                            id = IconId.Triangle;
                            break;
                    }
                    if (!dupe) {
                        let icon: iconTool = new iconTool(this.tvd, isBullTrend ? state.buCol : state.beCol, state.style.pivot.size, realDepth?.id ?? id, realDepth?.rotate ?? rotate);
                        if (realDepth) {
                            icon?.build(this.getPtByOff(realDepth.p, state.style.pivot, realDepth.isLow));
                            state.pivots.push({
                                tool: icon,
                                isBull: isBullTrend,
                                pt: realDepth.p,
                                isLow: realDepth.isLow
                            });
                            icon = new iconTool(this.tvd, isBullTrend ? state.buCol : state.beCol, state.style.pivot.size, id, rotate);
                            realDepth = null;
                        }
                        icon.build(this.getPtByOff(move, state.style.pivot, isLow));
                        state.pivots.push({
                            tool: icon,
                            isBull: isBullTrend,
                            pt: move,
                            isLow: isLow
                        });
                        if (drawnState)
                            drawnState.icon = icon;

                        if (this.fractal && id == IconId.Triangle && structTool.isVirtual(move)) {
                            icon = new iconTool(this.tvd, hub.tvConfig.paneProperties.background, Math.max(0, state.style.pivot.size - 4), IconId.Triangle, rotate);
                            icon.fixedColor = icon.color;
                            icon.build(this.getPtByOff(move, state.style.pivot, isLow));
                            state.pivots.push({
                                tool: icon,
                                isBull: isBullTrend,
                                pt: move,
                                isLow: isLow
                            });
                        }
                    }
                    if (dupe && drawnState && combineDupes)
                        dupe = false;
                    if (move.i != null && s.pivot.txtOn && !dupe) {
                        let info: string = '';
                        if (this.simple) {
                            if (isLow)
                                info = '\n\n' + move.i.toString() + ',' + i;
                            else
                                info = move.i.toString() + ',' + i + '\n\n ';
                        } else {
                            if (hub.options.isAdmin && hub.smcConfig.struct.pon) {
                                info = move.i.toString();
                            } else {
                                if (isSet(s.pivot.flgs, PivotTxtFlgs.HH)) {
                                    if (s.pivot.txtUC)
                                        info = isBullTrend ? (isLow ? 'HL' : 'HH') : (isLow ? 'LL' : 'LH');
                                    else
                                        info = isBullTrend ? (isLow ? 'hl' : 'hh') : (isLow ? 'll' : 'lh');

                                }
                                if (isSet(s.pivot.flgs, PivotTxtFlgs.H)) {
                                    if (s.pivot.txtUC)
                                        info = isLow ? 'L' : 'H';
                                    else
                                        info = isLow ? 'l' : 'h';
                                }
                            }
                            if (idx > 0 && isSet(s.pivot.flgs, PivotTxtFlgs.Level)) {
                                if (info)
                                    info += '.';
                                info += structTool.getNum(idx, s.pivot.txtUC, hub.smcConfig.struct.swing.minorTxtStyle);
                            }
                        }
                        if (drawnState?.label) {
                            const prevText = drawnState.label.getText();
                            drawnState.label.setText(prevText + ',' + info);
                        } else {
                            const label = this.addPivot(drawnState?.state ?? state, info, move, isBullTrend, !isLow, structTool.isVirtual(move));
                            if (label && drawnState)
                                drawnState.label = label;
                        }
                    }
                    if (this.simple) {
                        if (i >= 0 && move.st) {
                            let icon = new iconTool(this.tvd, isBullTrend ? state.buCol : state.beCol, 12, IconId.Triangle, !isLow);
                            icon.build(this.getPtByOff(move.st, state.style.pivot, isLow));
                            state.pivots.push({
                                tool: icon,
                                isBull: isBullTrend,
                                isLow: isLow,
                                pt: move.st,
                            });
                        }
                    } else if (move.st && idx == 0) {
                        realDepth = {
                            p: move.st,
                            isLow: !isLow,
                            //isBullTrend: isBullTrend,
                            id: id,
                            rotate: !rotate
                        };
                    }

                }

                if (state.anyToRenderNext && move.ch)
                    this.buildMovesInternal(idx + 1, move.ch, drawn, move.i);

                if (i >= 0)
                    state.counter.pivot.add();

                if (b)
                    state.counter.bos.add();
                state.counter.total.add();
            }
        }
        if (state.anyToRenderNext && !state.anyToRender)
            for (let i = moves.length - 1; i >= 0; i--) {
                let move = moves[i];
                if (move.ch)
                    this.buildMovesInternal(idx + 1, move.ch, drawn, move.i);
                state.counter.pivot.add();
                if (move.fb || move.b)
                    state.counter.bos.add();
                state.counter.total.add();
            }
    }

    clear() {
        for (const state of this.states) {
            state.trends.forEach(x => x.tool.clear());
            state.boses.forEach(x => x.tool.clear());
            state.pivots.forEach(x => x.tool.clear());
            state.pivotNames.forEach(x => x.tool.clear());
            state.levels.forEach(x => x.tool.clear());

            state.trends = [];
            state.boses = [];
            state.pivots = [];
            state.pivotNames = [];
            state.levels = [];
        }
    }
}
export class fractalStructTool extends structTool {
    constructor(tv: TVContext) {
        super(tv, null);
        this.buildState(0);
    }

    override getStyle(lvl: number): StructMoveStyle { return hub.smcConfig.struct.fractal; }

    protected override afterInitView(idx: number) {
        this.states[idx].style.trend.on = false;
        this.states[idx].style.pivot.txtOn = false;
    }

    override build(mi: SmpaTFInfo, drawn: Map<number, IDrawn>) {
        super.build(mi, drawn);
        if (mi.fractal
            && hub.smcConfig.struct.on
            && hub.smcConfig.struct.fractal.on)
            this.buildMovesInternal(0, mi.fractal, drawn);
    }
}
export class swingStructTool extends structTool {
    static get max() { return hub.options.isAdmin ? 1000 : 100; }

    constructor(tv: TVContext, fractal: fractalStructTool) { super(tv, fractal); }

    override getStyle(idx: number): StructMoveStyle {
        const swing = hub.smcConfig.struct.swing;
        if (idx == 0)
            return swing.major;
        idx -= 1;
        if (idx >= swing.minors.length)
            return swing.minors[swing.minors.length - 1];
        return swing.minors[idx];
    }

    override getColor(idx: number, isBull: boolean, opacity: number): string {
        const color = isBull ? this.getStyle(idx).buCol : this.getStyle(idx).beCol;
        return getColor(color, opacity / 100);
    }

    override afterInitView(idx: number) {
        super.afterInitView(idx);
        const state = this.states[idx];
        const style = this.getStyle(idx) as StructSwingStyle;
        state.supportsFbos = style.fbos;
        state.supportsLvls = style.lvl.on;
        state.lvlBeTextCol = this.getColor(idx, false, style.lvl.txtOp);
        state.lvlBuTextCol = this.getColor(idx, true, style.lvl.txtOp);
        if (style.lvl.on || state.supportsFbos)
            state.anyToRender = true;
        if (!style.on)
            state.anyToRender = false;
        state.anyToRenderNext = false;
        const minors = hub.smcConfig.struct.swing.minors;
        if (idx >= minors.length) {
            const nextStyle = this.getStyle(minors.length) as StructSwingStyle;
            state.anyToRenderNext = nextStyle.on && (nextStyle.bos.on || nextStyle.pivot.on || nextStyle.trend.on || nextStyle.fbos || nextStyle.lvl.on);
        } else for (let i = idx; i < minors.length && !state.anyToRenderNext; i++) {
            const nextStyle = this.getStyle(i + 1) as StructSwingStyle;
            state.anyToRenderNext = nextStyle.on && (nextStyle.bos.on || nextStyle.pivot.on || nextStyle.trend.on || nextStyle.fbos || nextStyle.lvl.on);
        }
    }

    override build(mi: SmpaTFInfo, drawn: Map<number, IDrawn>) {
        super.build(mi, drawn);
        if (mi.swing && hub.smcConfig.struct.on) {
            this.buildMovesInternal(0, mi.swing, drawn, null);

            this.addLevels(mi);
        }
    }

    private addLevels(mi: SmpaTFInfo) {
        if (!mi.swinglvls)
            return;
        const lvls = new Map<number, StructLevel[]>();

        for (let i = 0; i < mi.swinglvls.length; i++) {
            const lvl = structTool.getLevel(mi.swinglvls[i].f);
            const style = this.getStyle(lvl) as StructSwingStyle;
            if (!style.lvl.on || !style.on)
                continue;

            let list = lvls.get(mi.swinglvls[i].p);
            if (list == null)
                lvls.set(mi.swinglvls[i].p, list = []);

            list.push(mi.swinglvls[i]);
        }
        for (const list of lvls.values()) {

            const isBullTrend = structTool.isBullTrend(list[0].f);
            let txts: string[] = [];
            txts.length = 2;
            let pos = list[0];

            for (const l of list) {
                const id = structTool.getLevel(l.f);
                const style = this.getStyle(id) as StructSwingStyle;
                if (style.lvl.txtOn) {
                    const ind = structTool.isBull(l.f) == structTool.isBullTrend(l.f) ? 0 : 1;
                    if (txts[ind])
                        txts[ind] += ',';
                    else
                        txts[ind] = '';
                    if (id > 0)
                        txts[ind] += structTool.getNum(id, style.pivot.txtUC, hub.smcConfig.struct.swing.minorTxtStyle);
                    else
                        txts[ind] = '.';

                }
                if (pos.t > l.t)
                    pos = l;
            }
            let txt: string = '';
            if (txts[0])
                if (txts[0] == '.')
                    txt = `weak`;
                else
                    txt = `weak(${txts[0]})`;
            if (txts[1]) {
                if (txt)
                    txt += ',';
                if (txts[1] == '.')
                    txt += `strong`;
                else
                    txt += `strong(${txts[1]})`;
            }

            const state = this.states[structTool.getLevel(list[0].f)];
            const textColor = isBullTrend ? state.lvlBuTextCol : state.lvlBeTextCol;
            const color = isBullTrend ? state.buCol : state.beCol;
            const lvlStyle = (state.style as StructSwingStyle).lvl;
            const tool = new hrTool(this.tvd, color, lvlStyle.lWidth, false, lvlStyle.lStyle, textColor);
            tool.setAligns(valign_center, markTools.getAlign(lvlStyle), lvlStyle.txtSz);
            tool.build(pos);

            if (txt)
                tool.setText(lvlStyle.txtUC ? txt.toUpperCase() : txt);
            state.levels.push({
                tool: tool, isBull: isBullTrend
            });
        }
    }
}
export class simpleStructTool extends structTool {
    constructor(tv: TVContext) { super(tv, null, true); }

    override getStyle(lvl: number): StructMoveStyle { return hub.smcConfig.struct.simple; }

    override afterInitView(idx: number) {
        super.afterInitView(idx);
        this.states[0].style.pivot.type = PivotType.Circle;
    }

    override build(mi: SmpaTFInfo, drawn: Map<number, IDrawn>) {
        super.build(mi, drawn);
        if (mi.simple && hub.smcConfig.struct.simple.on) {
            drawn = new Map<number, IDrawn>();
            this.buildMovesInternal(0, mi.simple, drawn);
        }
    }
}
